import styled from "styled-components";

export const Container = styled.div`
  padding: 70px 116px;

  form {
    display: flex;
    flex-direction: column;
    gap: 20px;
    margin-block: 40px;
  }
`;
